<template>
  <v-dialog 
    :value="value"
    transition="dialog-top-transition" 
    max-width="30vw"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-toolbar color="primary" dark>
      <v-toolbar-title>Создать дашборд</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-form ref="form">
        <v-container fluid>
          <v-row class="mt-n2">
            <v-col>
              <v-text-field label="Имя дашборда" v-model="name" counter :rules="rule"/>
            </v-col>
          </v-row>

          <!-- <v-row class="mt-n2">
            <v-col>
              <v-text-field label="Англ. имя дашборда" v-model="nameEn" disabled/>
            </v-col>
          </v-row> -->
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="warning"
            text
            @click="close"
          >
            Отмена
          </v-btn>

          <v-btn
            color="success"
            text
            @click="preCreate"
          >
            Создать
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CreateDashboard',
  components: {
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      name: '',
      nameEn: '',
      rule: [
        str => str.length > 20 ? 'не больше 20 символов' : true,
        str => str.length < 3  ? 'не меньше 3 символов'  : true,
      ],
    }
  },

  computed: {
    ...mapGetters({

    }),

  },

  watch: {
    name(val) {
      this.nameEn = this.utils.transcript(val);
    },
  },

  methods: {
    ...mapActions({
      createDashboard: 'dashboard/createDashboard',
    }),
    
    close() {
      this.$emit('input', false);
    },

    async preCreate() {
      if (!this.$refs.form.validate()) return;
      let n_dashboard = {};
      let content = {
        name: this.nameEn,
        title: this.name,
        tab_order: 0,
        widgets: [],
      }
      n_dashboard.is_private = true;
      n_dashboard.content = JSON.stringify(content);
      await this.createDashboard(n_dashboard);
      this.$emit('created');
      this.close();
    },
  },

  mounted() {

  }

}
</script>


<style scoped lang="scss">

</style>